import {
  COLOR_MARKET_INSIGHT_OWN_HOTEL,
  getCssVariableValue,
} from 'frontend-utils/utils/css-variable';

export const GOOGLE_MAPS_SHARED_CONFIG = {
  minZoom: 5, // Don't allow users to zoom out too far
  scrollwheel: false, // Disable the zoom on scroll
  fullscreenControl: false, // Disable full screen toggle
  mapTypeControl: false, // Disable Map/Satellite view toggle
  streetViewControl: false, // Disable street view
  rotateControl: true, // Disabled angled view
  clickableIcons: false, // Disable clickable place names/POIs
  zoomControl: false, // Enable zoom control
  cameraControl: false, // Disable camera control
};

export const GOOGLE_MAPS_OWN_HOTEL = getCssVariableValue(
  COLOR_MARKET_INSIGHT_OWN_HOTEL,
);

export const getGoogleMapsStyles = (): Record<
  'BLACK_AND_WHITE',
  google.maps.MapTypeStyle[]
> => ({
  BLACK_AND_WHITE: [
    {
      elementType: 'geometry',
      stylers: [
        { color: getCssVariableValue('--prism-color-general-neutral-100') },
      ],
    },
    {
      elementType: 'labels.icon',
      stylers: [{ visibility: 'off' }],
    },
    {
      elementType: 'labels.text.fill',
      stylers: [
        { color: getCssVariableValue('--prism-color-general-neutral-800') },
      ],
    },
    {
      elementType: 'labels.text.stroke',
      stylers: [
        { color: getCssVariableValue('--prism-color-general-neutral-100') },
      ],
    },
    {
      featureType: 'administrative',
      elementType: 'geometry',
      stylers: [{ visibility: 'off' }],
    },
    {
      featureType: 'administrative.land_parcel',
      elementType: 'labels.text.fill',
      stylers: [
        { color: getCssVariableValue('--prism-color-general-neutral-500') },
      ],
    },
    {
      featureType: 'poi',
      stylers: [{ visibility: 'off' }],
    },
    {
      featureType: 'poi',
      elementType: 'geometry',
      stylers: [
        { color: getCssVariableValue('--prism-color-general-neutral-100') },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'labels.text.fill',
      stylers: [
        { color: getCssVariableValue('--prism-color-general-neutral-700') },
      ],
    },
    {
      featureType: 'poi.park',
      elementType: 'geometry',
      stylers: [
        { color: getCssVariableValue('--prism-color-general-neutral-200') },
      ],
    },
    {
      featureType: 'poi.park',
      elementType: 'labels.text.fill',
      stylers: [
        { color: getCssVariableValue('--prism-color-general-neutral-700') },
      ],
    },
    {
      featureType: 'road',
      elementType: 'labels.icon',
      stylers: [{ visibility: 'off' }],
    },
    {
      featureType: 'road',
      elementType: 'geometry',
      stylers: [
        { color: getCssVariableValue('--prism-color-general-neutral-00') },
      ],
    },
    {
      featureType: 'road.arterial',
      elementType: 'labels.text.fill',
      stylers: [
        { color: getCssVariableValue('--prism-color-general-neutral-600') },
      ],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry',
      stylers: [
        { color: getCssVariableValue('--prism-color-general-neutral-300') },
      ],
    },
    {
      featureType: 'road.highway',
      elementType: 'labels.text.fill',
      stylers: [
        { color: getCssVariableValue('--prism-color-general-neutral-800') },
      ],
    },
    {
      featureType: 'road.local',
      elementType: 'labels.text.fill',
      stylers: [
        { color: getCssVariableValue('--prism-color-general-neutral-600') },
      ],
    },
    {
      featureType: 'transit',
      stylers: [{ visibility: 'off' }],
    },
    {
      featureType: 'transit.line',
      elementType: 'geometry',
      stylers: [
        { color: getCssVariableValue('--prism-color-general-neutral-200') },
      ],
    },
    {
      featureType: 'transit.station',
      elementType: 'geometry',
      stylers: [
        { color: getCssVariableValue('--prism-color-general-neutral-100') },
      ],
    },
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [
        { color: getCssVariableValue('--prism-color-general-neutral-400') },
      ],
    },
    {
      featureType: 'water',
      elementType: 'labels.text.fill',
      stylers: [
        { color: getCssVariableValue('--prism-color-general-neutral-600') },
      ],
    },
  ],
});
